import { useTranslations } from 'next-intl';
import Link from 'next/link';

export const TermsAndPrivacy = () => {
  const t = useTranslations('Auth');
  return (
    <p className="flex-1 text-center text-body-sm leading-none text-[#606384] [font-feature-settings:'ss03'_on,'ss11'_on]">
      {t('by_email_continue')}
      <span style={{ color: '#606384' }}>
        <Link
          href="/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          {t('terms')}
        </Link>
        {' '}
        &
        {' '}
        <Link
          href="/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          {t('privacy_policy')}
        </Link>
        .
      </span>
    </p>
  );
};
